import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, LoadingService } from '@shared/src/public-api';
import { BaseController } from '../../base.controller';

@Injectable({
    providedIn: 'root',
})
export class CommandController extends BaseController {

    private base = '/command'
    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        protected router: Router,
        @Inject('LoadingService') protected loadingService: LoadingService) {
        super(http, alertService, translateService, loadingService, router);

    }
    public postCommand(command: string): Observable<CommandResult> {
        return this.postBusy(this.base + "/", command, "postCommand");
    }
}

export class CommandResult {
    public result: boolean = true;
    public steps: CommandStepDTO[] = [];
}
export class CommandStepDTO {
    public type: string;
    public text: string;
}